import React from "react";
import BlogsList from "../BlogPage/BlogsList";

const Blogs = () => {
  return (
    <div className="py-6 sm:py-20 sm:mx-12 flex flex-col gap-5 sm:gap-10 justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <h3 className="jost-regular text-primary text-xl sm:text-2xl py-4 uppercase">
          Blogs and News
        </h3>
        <h1 className="jost-regular !font-[500] text-3xl text-center sm:text-5xl">
          Blogs and Articles
          <span className="italic mx-3 tracking-[-3px] font-eiko-thin text-primary">
            From Mindio
          </span>
        </h1>
      </div>

      <BlogsList />
    </div>
  );
};

export default Blogs;
